<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.plate">
    <person-details-content slot-scope="{data}" :vehicle="data"></person-details-content>
  </l-cache>
</template>

<script>
import PersonDetailsContent from './personDetailsContent'

export default {
  name: 'PersonStatisticDetails',
  components: {PersonDetailsContent},
  methods: {
    async getItem (key) {
      let {items} = await this.$store.dispatch('personPassControl/searchVehicles', {plate: key})
      if (items.length) {
        //console.log(items)
        return items[0]
      }
      else {
        throw Error('未找到该行人')
      }
    }
  }
}
</script>

<style scoped>

</style>
